import { render, staticRenderFns } from "./BuyerUnits.vue?vue&type=template&id=65aeed90&scoped=true&"
import script from "./BuyerUnits.vue?vue&type=script&lang=js&"
export * from "./BuyerUnits.vue?vue&type=script&lang=js&"
import style0 from "./BuyerUnits.vue?vue&type=style&index=0&id=65aeed90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aeed90",
  null
  
)

export default component.exports